import { useApolloClient } from "@apollo/client";
import { getDataOrNull } from "@msys/common";
import { uniq } from "lodash-es";
import React from "react";
import { TagGroup } from "../../../clients/graphqlTypes.js";
import { useOrganisationTagsQuery } from "./useOrganisationTags.generated.js";

export const useOrganisationTags = (group: TagGroup) => {
  const client = useApolloClient();
  const tagsQuery = useOrganisationTagsQuery({
    client,
    variables: { group, includeSubscribedTemplateTags: group === "TEMPLATE" },
  });
  const { tags, customTags, systemTags } = React.useMemo((): {
    tags: string[];
    customTags: string[];
    systemTags: string[];
  } => {
    const organisation = getDataOrNull(tagsQuery.data?.viewer)?.organisation;
    const customTags = organisation?.customTags ?? [];
    const systemTags = organisation?.systemTags ?? [];
    const subscribedTemplateTags = organisation?.subscribedTemplateTags ?? [];
    const tags = uniq([
      ...systemTags,
      ...customTags,
      ...subscribedTemplateTags,
    ]).sort((t1, t2) => t1.localeCompare(t2));
    const customAndSubscribedTags = uniq([
      ...customTags,
      ...subscribedTemplateTags,
    ]).sort((t1, t2) => t1.localeCompare(t2));
    return { tags, systemTags, customTags: customAndSubscribedTags };
  }, [tagsQuery.data?.viewer]);
  return { tagsQuery, tags, customTags, systemTags };
};
